// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__dTxbK","author":"Table_author__1LCfL","authorImage":"Table_authorImage__1wjhh","unreadRow":"Table_unreadRow__1AEWY"};